import Marquee from "react-fast-marquee";

export const TextMarquee = ({ items }) => (
  <div data-testid="text-marquee" className="py-10 md:py-16 border-y border-white/10 overflow-hidden select-none" aria-hidden="true">
    <Marquee speed={35} gradient={false}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-7xl md:text-9xl text-outline px-6 leading-none">{item}</span>
          <span className="w-3 h-3 md:w-4 md:h-4 bg-primary rotate-45 mx-4" />
        </span>
      ))}
    </Marquee>
  </div>
);
